import { announcement } from "./admin/announcements/announcements";
import { logoSettings } from "./admin/employeePageDesign/LogoSettings";
import { logoSettingsPreview } from "./admin/employeePageDesign/logoSettingsPreview";
import { theme } from "./admin/employeePageDesign/theme";
import { themePreview } from "./admin/employeePageDesign/themePreview";
import { healthLinks } from "./admin/healthLinks/HealthLinks";
import { changePassword } from "./auth/changePassword";
import { createDependent, createDependentRequest } from "./auth/createDependent";
import { claimList } from "./claim/claimList";
import { sendContactUsEmail } from "./contactUs/contactUs";
import { editMemberDetailsChangeRequest } from "./editMemberDetails/editMemberDetails";
// import { emailBrochure, emailBrochureVEBEnrollment } from "./enrollment/emailBrochure";
import {
	emailBrochure,
	emailBrochureV2,
	emailBrochureVEBEnrollment,
	scheduleAppointment
} from "./enrollment/emailBrochure";
import { addBopEnrollment, enrollment } from "./enrollment/enrollment";
import { getEnrollmentGroupAndVEB } from "./enrollment/get.enrollment.groupAndVEB";
import { findMemberEmail, findMemberSSN } from "./global/find";
import { group } from "./group/group";
import { getExistsMemberEnrollemnt, member } from "./member/member";
import { healthCard } from "./healthCard/healthCard";
import {
	getMemberNotificationCount,
	getMemberNotificationsBySSNAndGroupNumber,
	setAllNotificationsAsOldBySSNAndGroupNumber
} from "./notification/memberNotification";
import { OTP } from "./OTP/OTP";
import { pages } from "./pages";
import { plan } from "./plan/plan";
import { redirection } from "./redirection/redirection";
import { user } from "./user/user";
import {
	deleteMemberUploadedFile,
	getFolderDocumentList,
	getGroupOwnerSharedDocument,
	getMemberUploadedFile,
	memberDocumentUpload
} from "./documentAdminstration/member/MemberDocumnet";
import {
	getActiveVEBEnrollmentWithRider,
	getCheckPreviousVEBEnrollment
} from "./enrollment/getCheckPreviousVEBEnrollment";
import { getCheckPreviousCoreEnrollment } from "./enrollment/getCheckPreviousCoreEnrollment";
import { getEnrollmentCurrentBenefitEmail } from "./enrollment/getEnrollmentCurrentBenefitEmail";

import { addPersonalHealthScore } from "./personalHealthScore/addPersonalHealthScore";
import { getPersonalHealthScoreBySSN } from "./personalHealthScore/getPersonalHealthScoreBySSN";
import { getPersonalHealthScoreHistoryBySSN } from "./personalHealthScore/getPersonalHealthScoreHistoryBySSN";
import { get } from "http";
import { editBeneficiary } from "./beneficiary/editBeneficiary";
import { viewSSNAddLog } from "./SSN/viewSSNLog";
import { getAlternateID } from "./alternateID/alternateID";
import { getSIUnderwritingByEnrollment, saveSIUnderwriting } from "./enrollment/wholeLifeQuestionAndSIUnderwriting.api";

export const api = {
	member: {
		getMember: member.getMember,
		getDependents: member.getDependents,
		getSpouseDetailsByEmployeeSSN: member.getSpouseDetailsByEmployeeSSN,
		getExistsMemberEnrollemnt: member.getExistsMemberEnrollemnt
	},
	find: {
		findMemberEmail,
		findMemberSSN
	},
	employeePageDesign: {
		getThemeColorByGroupNumber: theme.getThemeColorByGroupNumber,
		getLogoSettingsByGroupNumber: logoSettings.getLogoSettingsByGroupNumber
	},
	employeePageDesignPreview: {
		getThemeColorsByGroupNumberAndUserId: themePreview.getThemeColorsByGroupNumberAndUserId,
		getLogoSettingsByGroupNumberAndUserId: logoSettingsPreview.getLogoSettingsByGroupNumberAndUserId
	},
	healthLinks: {
		getHealthLinkByGroupNumber: healthLinks.getHealthLinkByGroupNumber,
		getHealthLinkByGroupNumberAndLocationNumber: healthLinks.getHealthLinkByGroupNumberAndLocationNumber
	},
	announcements: {
		getAnnouncementByGroupAndLocation: announcement.getAnnouncementByGroupAndLocation
	},
	group: {
		getGroupAndLocation: group.getGroupAndLocation,
		getGroupByAuth: group.getGroupByAuth,
		getGroupByGroupNumber: group.getGroupByGroupNumber
	},
	OTP: {
		sendToEmail: OTP.sendToEmail,
		verifyOTP: OTP.verifyOTP
	},
	claim: {
		getClaimList: claimList.getClaimList,
		getClaimListV2: claimList.getClaimListV2,
		getEOBDetails: claimList.getEOBDetails,
		getEOBDetailsV2: claimList.getEOBDetailsV2,
		getEOBDetailsWithCheckNumber: claimList.getEOBDetailsWithCheckNumber,
		getEOBDetailsV3: claimList.getEOBDetailsV3,
		getClaimStatusDetails: claimList.getClaimStatusDetails
	},
	auth: {
		changePassword: changePassword,
		createDependent: createDependent,
		createDependentRequest: createDependentRequest
	},
	redirection: {
		redirectUser: redirection.redirectUser
	},
	user: {
		getMemberAndPaycheck: user.getMemberAndPaycheck,
		getMember: user.getMember
	},
	pages: {
		getMemberPortalInitData: pages.getMemberPortalInitData,
		getEnrollmentInitData: pages.getEnrollmentInitData,
		getVEBEnrollmentInitData: pages.getVEBEnrollmentInitData,
		getDependentPortalInitData: pages.getDependentPortalInitData,
		getAccidentPlanInitData: pages.getAccidentPlanInitData
	},
	enrollment: {
		addEnrollment: enrollment.addEnrollment,
		addDynamicEnrollments: enrollment.addDynamicEnrollments,
		addPlEnrollment: enrollment.addPlEnrollment,
		addBopEnrollment: enrollment.addBopEnrollment,
		getHOOEnrollment: enrollment.getHOOEnrollment,
		addNonOEEnrollment: enrollment.addNonOEEnrollment,
		getEnrollmentGroupAndVEB: getEnrollmentGroupAndVEB,
		getBenefits: enrollment.getBenefits,
		getBenefitsV2: enrollment.getBenefitsV2,
		addVEBEnrollment: enrollment.addVEBEnrollment,
		existsVEBEnrollment: enrollment.existsVEBEnrollment,
		updateVebEnrollment: enrollment.updateVebEnrollment,
		getVEBBenefits: enrollment.getVEBBenefits,
		getVEBRidersByPlan: enrollment.getVEBRidersByPlan,
		getDependentBenefits: enrollment.getDependentBenefits,
		getVEBDependentBenefits: enrollment.getVEBDependentBenefits,
		getCriticalIllnessWithCancerEnrollment: enrollment.getCriticalIllnessWithCancerEnrollment,
		getCancerEnrollment: enrollment.getCancerEnrollment,
		getAccidentDisablityRiderEnrollment: enrollment.getAccidentDisablityRiderEnrollment,
		getShortTermDisablityEnrollment: enrollment.getShortTermDisablityEnrollment,
		stackCriticalIllnessEnrollment: enrollment.stackCriticalIllnessEnrollment,
		getActiveHealthPlan: enrollment.getActiveHealthPlan,
		getActiveDentalPlan: enrollment.getActiveDentalPlan,
		getActiveVisionPlan: enrollment.getActiveVisionPlan,
		getActiveClinicCard: enrollment.getActiveClinicCard,
		getActiveBeazelyClinicCardRider: enrollment.getActiveBeazelyClinicCardRider,
		getBeneficiaryDetails: enrollment.getBeneficiaryDetails,
		stackWholeLifeEnrollment: enrollment.stackWholeEnrollment,
		getActiveVEBEnrollments: enrollment.getActiveVEBEnrollments,
		getCheckPreviousVEBEnrollment,
		getCheckPreviousCoreEnrollment,
		getActiveVEBEnrollmentWithRider,
		getEnrollmentCurrentBenefitEmail: getEnrollmentCurrentBenefitEmail,
		saveSIUnderwriting: saveSIUnderwriting,
		getSIUnderwritingByEnrollment: getSIUnderwritingByEnrollment
	},
	plan: {
		getPlansWithRider: plan.getPlansWithRider,
		getParticularPlans: plan.getParticularPlans,
		getVEBPlans: plan.getVEBPlans,
		getPlans: plan.getPlans
	},
	contactUs: {
		sendContactUsEmail: sendContactUsEmail
	},
	notification: {
		getMemberNotificationsBySSNAndGroupNumber,
		setAllNotificationsAsOldBySSNAndGroupNumber,
		getMemberNotificationCount
	},
	email: {
		emailBrochure: emailBrochure,
		emailBrochureV2: emailBrochureV2,
		emailBrochureVEBEnrollment: emailBrochureVEBEnrollment
	},
	editMemberDetails: {
		editMemberDetailsChangeRequest: editMemberDetailsChangeRequest,
		// emailBrochureVEBEnrollment: emailBrochureVEBEnrollment,
		scheduleAppointment: scheduleAppointment
	},
	healthCard: {
		emailHealthCard: healthCard.emailHealthCard
	},
	documentAdminstration: {
		memberDocumentUpload: memberDocumentUpload,
		fetchMemberDocumentList: getMemberUploadedFile,
		getFolderDocumentList: getFolderDocumentList,
		fetchGroupOwnerSharedDocumentList: getGroupOwnerSharedDocument,
		deleteMemberDocument: deleteMemberUploadedFile
	},
	personalHealthScore: {
		addPersonalHealthScore,
		getPersonalHealthScoreBySSN,
		getPersonalHealthScoreHistoryBySSN
	},
	beneficiary: {
		editBeneficiary
	},
	SSN: {
		viewSSNAddLog: viewSSNAddLog
	},
	alternateID: {
		getAlternateID: getAlternateID
	}
};
